import { render, staticRenderFns } from "./bindMaterialDialog.vue?vue&type=template&id=0d5f385c&scoped=true&"
import script from "./bindMaterialDialog.vue?vue&type=script&lang=js&"
export * from "./bindMaterialDialog.vue?vue&type=script&lang=js&"
import style0 from "./bindMaterialDialog.vue?vue&type=style&index=0&id=0d5f385c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f385c",
  null
  
)

export default component.exports